import SummaryHeaderAnalyticsMetric from './SummaryHeaderAnalyticsMetric';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { isUngatedToCHIRPEndpoints } from 'documents-ui/utils/gates';
import { useGetSummaryAnalytics } from '../../hooks/useGetSummaryAnalytics';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SummaryHeaderAnalytics = ({
  documentId,
  numShares: numSharesREST,
  numUniqueVisitors: numUniqueVisitorsREST,
  numViews: numViewsREST
}) => {
  var _documentAnalyticsSum, _documentAnalyticsSum2, _documentAnalyticsSum3;
  const isUngatedToChirp = isUngatedToCHIRPEndpoints();
  const {
    data: documentAnalyticsSummary
  } = useGetSummaryAnalytics({
    documentId
  });
  const numSharesCHIRP = (documentAnalyticsSummary === null || documentAnalyticsSummary === void 0 || (_documentAnalyticsSum = documentAnalyticsSummary.documentAnalyticsSummaryView) === null || _documentAnalyticsSum === void 0 ? void 0 : _documentAnalyticsSum.numShares) || null;
  const numShares = isUngatedToChirp ? numSharesCHIRP : numSharesREST;
  const numUniqueVisitorsCHIRP = (documentAnalyticsSummary === null || documentAnalyticsSummary === void 0 || (_documentAnalyticsSum2 = documentAnalyticsSummary.documentAnalyticsSummaryView) === null || _documentAnalyticsSum2 === void 0 ? void 0 : _documentAnalyticsSum2.numUniqueVisitors) || null;
  const numUniqueVisitors = isUngatedToChirp ? numUniqueVisitorsCHIRP : numUniqueVisitorsREST;
  const numViewsCHIRP = (documentAnalyticsSummary === null || documentAnalyticsSummary === void 0 || (_documentAnalyticsSum3 = documentAnalyticsSummary.documentAnalyticsSummaryView) === null || _documentAnalyticsSum3 === void 0 ? void 0 : _documentAnalyticsSum3.numViews) || null;
  const numViews = isUngatedToChirp ? numViewsCHIRP : numViewsREST;
  return /*#__PURE__*/_jsxs(Flex, {
    paddingInlineStart: "200",
    maxInlineSize: "500px",
    children: [/*#__PURE__*/_jsx(SummaryHeaderAnalyticsMetric, {
      dataTestId: "summary-header-analytics-links-created",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "summary.header.analytics.linksCreated"
      }),
      count: numShares
    }), /*#__PURE__*/_jsx(SummaryHeaderAnalyticsMetric, {
      dataTestId: "summary-header-analytics-visitors",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "summary.header.analytics.visitors"
      }),
      count: numUniqueVisitors
    }), /*#__PURE__*/_jsx(SummaryHeaderAnalyticsMetric, {
      dataTestId: "summary-header-analytics-views",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "summary.header.analytics.views"
      }),
      count: numViews
    })]
  });
};
export default SummaryHeaderAnalytics;